/** Query parameter names treated as secret-like and redacted from any diagnostic output. */
const SENSITIVE_PARAMS = ['ticket', 'token', 'secret', 'password', 'apiKey', 'api_key']

/**
 * Builds the chart iframe URL exactly as `ChartView.show()` does, from a base
 * URL plus the individual fields, so the harness exercises the same
 * construction the supplied implementation uses.
 */
export function buildChartIframeUrl(
  baseUrl: string,
  params: {
    tournamentId: string
    playerId: string
    ticket: string
    wsBaseUrl: string
    symbol: string
  }
): string {
  const host = new URL(params.wsBaseUrl).host

  return (
    baseUrl +
    '?tournament=true' +
    '&tournamentId=' +
    encodeURIComponent(params.tournamentId) +
    '&userId=' +
    encodeURIComponent(params.playerId) +
    '&ticket=' +
    encodeURIComponent(params.ticket) +
    '&wsUrl=' +
    encodeURIComponent(host) +
    '&symbol=' +
    encodeURIComponent(params.symbol.replace('/', ''))
  )
}

/**
 * Returns a copy of `url` with sensitive query parameter values replaced by
 * `[redacted]`, safe to print to the console or render in harness diagnostics.
 */
export function redactSensitiveUrl(url: string): string {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return '[unparseable url]'
  }

  for (const [key] of Array.from(parsed.searchParams.entries())) {
    if (SENSITIVE_PARAMS.some((sensitive) => sensitive.toLowerCase() === key.toLowerCase())) {
      parsed.searchParams.set(key, '[redacted]')
    }
  }

  return parsed.toString()
}
